/** W80 (W3): Ziele der Gaist-Karte mit Anker (`/einstellungen#erinnerungen`, Posteingang `#aufgaben`). Der Router scrollt
 *  nicht selbst dorthin; die Seite holt den Abschnitt ins Bild, sobald er steht (`bereit`, etwa nach dem Laden der Liste).
 *  Mittig statt oben: oben laege er unter der festen Titelleiste. */
import { useEffect, useRef } from "react";
import { useLocation } from "react-router";

/** So lange haelt die Seite den Abschnitt im Bild, waehrend darueber noch Inhalt nachlaedt. */
const NACHLADEN_MS = 2000;
/** Eingaben des Nutzers: danach holt die Seite den Abschnitt nicht mehr von selbst ins Bild. */
const EREIGNISSE = ["wheel", "touchstart", "pointerdown", "keydown"] as const;

export function useAnker(id: string, bereit = true): void {
  const { hash, key } = useLocation();
  // Verifier R2 W80-W: die Ueberschrift steht schon, bevor die Liste geladen ist (`bereit`). Wer in dieser Zeit selbst wischt,
  // wurde danach doch zum Abschnitt zurueckgeholt; darum merkt sich die Seite die Eingabe ab dem Navigieren, nicht erst ab `bereit`.
  const bedient = useRef<string | null>(null);
  useEffect(() => {
    if (hash !== `#${id}`) return;
    const merken = () => {
      bedient.current = key;
    };
    for (const e of EREIGNISSE) window.addEventListener(e, merken, { passive: true });
    return () => {
      for (const e of EREIGNISSE) window.removeEventListener(e, merken);
    };
  }, [hash, key, id]);
  useEffect(() => {
    if (!bereit || hash !== `#${id}` || bedient.current === key) return;
    const zeigen = () => document.getElementById(id)?.scrollIntoView?.({ block: "center" });
    zeigen();
    // Verifier R1 W80-W: im Posteingang laedt ueber den Aufgaben noch die Pruefkarte nach und schob die Ueberschrift auf dem
    // Handy unter die Tab-Leiste. Bis die Seite steht, waechst sie, und der Abschnitt kommt wieder ins Bild; nie gegen den
    // Nutzer (Wischen, Tippen, Taste beenden das).
    if (typeof ResizeObserver === "undefined") return;
    let aus = false;
    const beobachter = new ResizeObserver(() => {
      if (!aus) zeigen();
    });
    beobachter.observe(document.body);
    const ende = () => {
      aus = true;
      beobachter.disconnect();
    };
    const uhr = setTimeout(ende, NACHLADEN_MS);
    for (const e of EREIGNISSE) window.addEventListener(e, ende, { passive: true });
    return () => {
      clearTimeout(uhr);
      ende();
      for (const e of EREIGNISSE) window.removeEventListener(e, ende);
    };
  }, [hash, key, id, bereit]);
}
